import { useEffect, useState } from 'react';

export const inputClass =
	'w-full p-2 bg-transparent border border-borderContent text-text placeholder:opacity-60';

const variants = {
	solid: 'bg-fill text-background',
	outline: 'border border-borderContent',
	danger: 'bg-red-600 text-white',
};

export const Button = ({ variant = 'solid', className = '', ...rest }) => (
	<button
		type='button'
		className={`px-3 py-2 text-sm transition-opacity hover:opacity-80 disabled:opacity-40 disabled:cursor-not-allowed ${variants[variant]} ${className}`}
		{...rest}
	/>
);

// A destructive button that needs a second click within a few seconds.
export const ConfirmButton = ({ children, confirmText, onConfirm, ...rest }) => {
	const [armed, setArmed] = useState(false);

	useEffect(() => {
		if (!armed) return;

		const timeout = setTimeout(() => setArmed(false), 4000);

		return () => clearTimeout(timeout);
	}, [armed]);

	return (
		<Button
			variant={armed ? 'danger' : 'outline'}
			onClick={() => {
				if (armed) {
					setArmed(false);
					onConfirm();
				} else {
					setArmed(true);
				}
			}}
			{...rest}>
			{armed ? confirmText || 'Click again to confirm' : children}
		</Button>
	);
};

export const ErrorText = ({ children, onDismiss }) =>
	children ? (
		<div className='flex flex-row gap-3 place-items-center text-sm bg-red-600 text-white px-3 py-2'>
			<span className='flex-1'>{children}</span>
			{onDismiss && (
				<button type='button' onClick={onDismiss} aria-label='Dismiss'>
					✕
				</button>
			)}
		</div>
	) : null;

export const Label = ({ title, children }) => (
	<label className='flex flex-col gap-1 text-sm'>
		<span className='opacity-70'>{title}</span>
		{children}
	</label>
);
